import { Helmet } from 'react-helmet-async'

export const ContactUs = () => {
  return (
    <div className='container my-10 mx-auto flex flex-col items-start bg-[#5E81AC] p-6 lg:h-auto text-white rounded-md'>
      <Helmet>
        <title className='text-xl font-semibold font-semibold'>
          {' '}
          تماس با ما
        </title>
        <meta
          name='description'
          content='بوک استوری - هر کتاب یک داستان، هر داستان یک زندگی دوباره'
        />
      </Helmet>
      <div className='w-full flex flex-col items-start my-6'>
        <h1 className='text-xl font-semibold font-semibold my-2 border-b-2 py-2 w-3/4'>
          پشتیبانی بوک استوری
        </h1>
        <p className='text-lg font-medium font-medium'>
          ما در بوک استوری تمام تلاش خود را به کار خواهیم گرفت تا شما بهترین
          تجربهٔ خرید را داشته باشید. اگر در طول فرآیند بازدیدتان از سایت، خرید
          و دریافت محصول به هر مشکل و نارضایتی که برخوردید لطفا ما را در جریان
          آن قرار دهید.
        </p>
      </div>
      <div className='w-full flex flex-col items-start my-6'>
        <h1 className='text-xl font-semibold font-semibold my-2 border-b-2 py-2 w-3/4'>
          پشتیبانی از طریق ایمیل
        </h1>
        <p className='text-lg font-medium font-medium'>
          در حال حاضر بهترین و سریع‌ترین مسیر پشتیبانی ارسال ایمیل به{' '}
          <a
            href='mailto:support@bookstory.com'
            className=' text-white  text-lg font-medium underline underline-offset-8'
          >
            support@gobookstory.com
          </a>{' '}
          است، همکاران ما در سریع‌ترین زمان ممکن بعد از دریافت ایمیل شما نسبت به
          مشکل پیش آمده اقدام خواهند نمود و شما را در جریان روند پشتیبانی قرار
          خواهند داد.
        </p>
      </div>
      <div className='w-full flex flex-col items-start my-6'>
        <h1 className='text-xl font-semibold font-semibold my-2 border-b-2 py-2 w-3/4'>
          پشتیبانی از طریق شبکه‌های اجتماعی
        </h1>
        <p className='text-lg font-medium font-medium'>
          همچنین می‌توانید ما را در شبکه‌های اجتماعی{' '}
          <a
            href='https://www.instagram.com/gobookstory'
            className='underline underline-offset-8'
            target='_blank'
            rel='noreferrer'
          >
            اینستاگرام
          </a>{' '}
          و{' '}
          <a
            href='https://twitter.com/gobookstory'
            className='underline underline-offset-8'
            target='_blank'
            rel='noreferrer'
          >
            توئیتر
          </a>{' '}
          نیز دنبال کنید و مشکل خود را از طریق دایرکت برای ما ارسال کنید و یا از
          طریق{' '}
          <a
            href='https://wa.me/message/W63YGS7YP54UG1'
            className='underline underline-offset-8'
            target='_blank'
            rel='noreferrer'
          >
            واتس آپ
          </a>{' '}
          و{' '}
          <a
            href='https://t.me/gobookstory'
            className='underline underline-offset-8'
            target='_blank'
            rel='noreferrer'
          >
            تلگرام
          </a>{' '}
          با ما در ارتباط باشید.
        </p>
      </div>
    </div>
  )
}
